import { Selfserve6 } from "../../../../src/components/images/support/workflows/Selfserve6.generated";
import { Selfserve7 } from "../../../../src/components/images/support/workflows/Selfserve7.generated";
import * as React from 'react';
export default {
  Selfserve6,
  Selfserve7,
  React
};